import { useSelector } from "react-redux";

import {
  AudioImage,
  AudioInfo,
  ReleaseLiveName,
  AudioName,
  AudioInfoWrapper as StyledAudioInfoWrapper,
  AudioDuration as StyledAudioDuration,
  TopInfo,
  BottomInfo,
} from "./styled";
import Typography from "../Typography";
import LiveIcon from "../LiveIcon";
import { useGetPodcastsQuery } from "../../api/podcastsApi";
import { AudioDuration } from "./AudioDuration";
import { AdultIconWithTooltip } from "../AdultIconWithTooltip";
import { useOpenDrawerTrack } from "../../hooks/useOpenDrawerTrack";
import { useMediaQuery } from "../../hooks/useMediaQuery";

const fallbackImgByType = {
  rock: "/coverRock.svg",
  mc: "/coverMc.svg",
  lite: "/coverLite.svg",
};

export const AudioInfoWrapper = () => {
  const currentContent = useSelector((state) => state.player.currentContent);
  const isRelease = useSelector(
    (state) => state.player.currentEntity === "release",
  );
  const streamType = useSelector((state) =>
    state.player.audioType === "stream"
      ? state.player.currentStreamType
      : undefined,
  );

  const { data: podcasts } = useGetPodcastsQuery(
    {},
    {
      skip: !isRelease,
    },
  );

  const playingReleasePodcast = podcasts?.find(
    (podcast) => podcast.id === currentContent.podcastId,
  );

  const openDrawer = useOpenDrawerTrack();
  const isDesktop = useMediaQuery("(min-width: 981px)");

  return (
    <StyledAudioInfoWrapper {...(isDesktop && { onPointerEnd: openDrawer })}>
      <AudioImage
        src={
          isRelease
            ? currentContent.cover?.small || playingReleasePodcast?.cover.small
            : currentContent.cover?.big ||
              fallbackImgByType[streamType] ||
              "/coverMissing.png"
        }
        alt={playingReleasePodcast?.title}
      />
      <AudioInfo>
        <TopInfo>
          <Typography variant="h4">
            {isRelease ? playingReleasePodcast?.title : currentContent.genre}
          </Typography>
          {isRelease && currentContent.isAdult && <AdultIconWithTooltip />}
        </TopInfo>
        {isRelease ? (
          <>
            {currentContent.isLive ? (
              <ReleaseLiveName>
                <LiveIcon />
                <Typography>Лайв • {currentContent.title}</Typography>
              </ReleaseLiveName>
            ) : (
              <BottomInfo>
                <Typography as={AudioName}>{currentContent.title}</Typography> •{" "}
                <AudioDuration />
              </BottomInfo>
            )}
          </>
        ) : (
          <BottomInfo>
            <Typography as={AudioName}>{currentContent.artist}</Typography> •{" "}
            <Typography as={StyledAudioDuration} isRelease={isRelease}>
              {currentContent.track}
            </Typography>
          </BottomInfo>
        )}
      </AudioInfo>
    </StyledAudioInfoWrapper>
  );
};
